<template>
  <div class="AiCustomerService">
    <div class="is-show-right">
      <p>是否开启AI</p>
      <el-switch
        v-model="value.isShow"
        active-color="#1989fa"
        size="mini"
        inactive-color="#333"
        @change="changeSetting"
      >
      </el-switch>
    </div>
    <div class="customerService" v-if="value.isShow">
      <span>窗口位置</span>
      <el-radio-group v-model="value.position" @change="switchChange">
        <el-radio label="left">靠左</el-radio>
        <el-radio label="right"> 靠右</el-radio>
      </el-radio-group>
    </div>
    <div class="url" v-if="value.isShow">
      <div class="u-header">地址</div>
      <div class="u-body">
        <el-input v-model="value.aiUrl" @change="switchChange" placeholder="请输入"></el-input>
      </div>
    </div>
    <div class="url" v-if="value.isShow">
      <div class="u-header">数字人地址</div>
      <div class="u-body">
        <el-input v-model="value.digitalhumanSrc" @change="switchChange" placeholder="请输入"></el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiCustomerService',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      value: {},
    };
  },
  components: {},
  mounted() {
    this.value = this.propertyData.digitalHuman.value;
  },
  methods: {
    switchChange() {
      this.changeSetting();
    },
    changeSetting() {
      console.log(this.value, '更新数据');
      /* 更新数据 */

      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: this.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.AiCustomerService {
  height: auto;
  padding: 20px 15px 0;
}

.customerService {
  margin-top: 24px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  color: #a0a1b4;
  font-size: 14px;
  :deep() .el-radio__label {
    padding-left: 6px;
  }
  :deep() .el-radio {
    color: #a0a1b4;
    cursor: pointer;
  }
}
.is-show-right {
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  color: #a0a1b4;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-select {
    width: 192px;

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
:deep().el-switch {
  margin: auto 0;
  .el-switch__core {
    background: #55597b;
    border: none;
    height: 10px;
    width: 30px !important;
    .el-switch__action {
      top: -2px;

      background: #c9cae5;

      width: 14px;
      height: 14px;
    }
  }
  &.is-checked {
    .el-switch__core {
      background: linear-gradient(143deg, #335ae9, #6f6ff5);
      .el-switch__action {
        left: 100%;
        background: #ffffff;
        margin-left: -14px;
      }
    }
  }
}
.url {
  box-sizing: border-box;
  // padding: 0 15px;
  width: 100%;
  // height: 30px;
  color: $property-title-color;
  font-size: $property-title-size;
  line-height: 30px;
  .u-body {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 40px;
    // padding: 0 15px;
    :deep().el-input input {
      height: 35px;
      color: #b6b8cc;
      background: #191b23;
      text-align: center;
      border: 1px solid rgba(139, 139, 139, 0.733);
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
.content-box {
  width: 100%;
}
.model-list {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;

  &::-webkit-scrollbar {
    width: 0;
  }

  .item {
    position: relative;
    width: calc((100% - 16px) / 3);
    aspect-ratio: 1/1;
    margin-top: 8px;
    margin-right: 8px;
    list-style: none;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;

    &:nth-child(3n) {
      margin-right: 0;
    }

    &:nth-child(-n + 3) {
      margin-top: 0;
    }

    .thumb {
      display: inline-block;
      width: 100%;
      height: 100%;

      img {
        display: flex;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .model-name,
    .img-name {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 0 6px;
      color: #fff;
      font-size: 12px;
      line-height: 20px;
      background-color: rgba($color: #000000, $alpha: 0.2);
      box-sizing: border-box;
    }
  }

  .select {
    &::before {
      z-index: 9;
      position: absolute;
      left: 0;
      top: 0;
      content: '';
      width: 22px;
      height: 22px;
      background-image: url('../../../assets/img/ai-model/select.svg');
      background-size: 100%;
      background-repeat: no-repeat;
    }

    &::after {
      z-index: 9;
      position: absolute;
      left: 0;
      top: 0;
      content: '';
      width: 100%;
      height: 100%;
      border-radius: 4px;
      box-shadow: inset 0 0 0 2px #2468f2;
    }
  }
}

.select {
  background-color: #e6f0ff;
}
</style>
